// @flow
import React, { Component, type Node } from 'react';

import { ResortListContext, type resortListContextType } from './ResortListContext';

type Props = {
  children: Node,
};

export class ResortListProvider extends Component<Props, resortListContextType> {
  state = {
    resortList: [],
    setResortList: (resortList: $PropertyType<resortListContextType, 'resortList'>) => {
      this.setState({
        resortList,
      });
    },
  };

  render() {
    return (
      <ResortListContext.Provider value={this.state}>
        {this.props.children}
      </ResortListContext.Provider>
    );
  }
}
